import React from "react";
import "./scss/global.scss";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Auth from "./auth"
import NotFoundPage from "./pages/User/NotFoundPage";
import {RouteAdmin} from "./routes/RouteAdmin";
import {RouteAuth} from "./routes/RouteAuth";
import {RouteUser} from "./routes/RouteUser";
import {Helmet} from "react-helmet";
import CheckRole from "./components/Auth/CheckRole";
import LayoutUser from "./components/Layouts/User";
import LayoutAdmin from "./components/Layouts/Admin";
import MaintenanceAdmin from "./components/Admin/MaintenanceAdmin";
import MaintenanceUser from "./components/User/MaintenanceUser";

export default function App() {

    return (
        <BrowserRouter>
            <Auth>
                <Routes>
                    {Object.keys(RouteAuth).map((item, key) => {
                        const e = RouteAuth[item]
                        return (
                            <Route key={key} path={`${e.path}${e.params ?? ""}`} element={
                                <>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>
                                    <CheckRole roles={e.roles}/>
                                    <e.page />
                                </>
                            } />
                        )
                    })}

                    {Object.keys(RouteUser).map((item, key) => {
                        const e = RouteUser[item]
                        return (
                            <Route key={key} path={`${e.path}${e.params ?? ""}`} element={
                                <LayoutUser>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>
                                    <CheckRole roles={e.roles}/>
                                    <MaintenanceUser path={e.path}/>
                                    <e.page />
                                </LayoutUser>
                            } />
                        )
                    })}

                    {Object.keys(RouteAdmin).map((item, key) => {
                        const e = RouteAdmin[item]
                        return (
                            <Route key={key} path={`${e.path}${e.params ?? ""}`} element={
                                <LayoutAdmin menuChild={e.menuChild} menu={e.menu}>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>
                                    <CheckRole roles={e.roles}/>
                                    <MaintenanceAdmin path={e.path}/>
                                    <e.page />
                                </LayoutAdmin>
                            } />
                        )
                    })}

                        <Route path='*' element={<NotFoundPage/>}/>
                </Routes>
            </Auth>
        </BrowserRouter>
    )
}
